import * as CaseListActions from './Actions';
const initialState = {
    viewAllListStatus: null,
    viewAllListSuccess: null,
    viewAllListFailure: null,
    viewPaginatedListStatus: null,
    viewPaginatedListSuccess: null,
    viewPaginatedListFailure: null,
    corporateNameList: [],
    corporateNameListFailure: [],
    epfData : [],
    epfError : null,
    availableProducts: [],
    productsLoading: false,
    productsError: null

}
const caseReducer = (state = initialState, action) => {
    switch (action.type) {
        case CaseListActions.VIEW_ALL_CASES:
            return state = {
                ...state,
                viewAllListStatus: action.data
            }
        case CaseListActions.VIEW_ALL_CASES_SUCCESS:
            return state = {
                ...state,
                viewAllListSuccess: action.data
            }
        case CaseListActions.VIEW_ALL_CASES_FAIL:
            return state = {
                ...state,
                viewAllListFailure: action.data
            }
        case CaseListActions.VIEW_PAGINATED_CASES:
            return state = {
                ...state,
                viewPaginatedListStatus: {
                    data: action.data.status,
                    pageNo: action.data.pageNo,
                    pageSize: action.data.pageSize,
                    sorted: action.data.sorted
                }
            }
        case CaseListActions.VIEW_PAGINATED_CASES_SUCCESS:
            return state = {
                ...state,
                viewPaginatedListSuccess: action.data
            }
        case CaseListActions.VIEW_PAGINATED_CASES_FAIL:
            return state = {
                ...state,
                viewPaginatedListFailure: action.data
            }
        case CaseListActions.FETCH_CORPORATE_NAME_SUCCESS:
            return state = {
                ...state,
                corporateNameList: action.data
            }
        case CaseListActions.FETCH_CORPORATE_NAME_FAILURE:
            return state = {
                ...state,
                corporateNameListFailure: action.data
            }
        // case CaseListActions.CASE_DETAILS_EPF_SUCCESS:
        //     return state = {
        //         ...state,
        //         epfData: action.data
        //     }
        // case CaseListActions.CASE_DETAILS_EPF_FAILURE:
        //     return state = {
        //         ...state,
        //         epfError: action.data
        //     }
        case CaseListActions.DOWNLOAD_PENDING_CASES_SUCCESS:
            return state = {
                ...state,
                    downloadPendingCases: action.data
            }
        case CaseListActions.DOWNLOAD_PENDING_CASES_FAILURE:
            return state = {
                ...state,
                downloadPendingCasesFailure: action.data
            }
        case CaseListActions.FETCH_PRODUCTS_BY_CORPORATES:
            console.log('Reducer: FETCH_PRODUCTS_BY_CORPORATES - setting loading to true');
            return state = {
                ...state,
                productsLoading: true,
                productsError: null
            }
        case CaseListActions.FETCH_PRODUCTS_BY_CORPORATES_SUCCESS:
            console.log('Reducer: FETCH_PRODUCTS_BY_CORPORATES_SUCCESS - storing products:', action.data);
            return state = {
                ...state,
                availableProducts: action.data,
                productsLoading: false
            }
        case CaseListActions.FETCH_PRODUCTS_BY_CORPORATES_FAILURE:
            console.log('Reducer: FETCH_PRODUCTS_BY_CORPORATES_FAILURE - error:', action.data);
            return state = {
                ...state,
                productsError: action.data,
                productsLoading: false
            }
        default: return state
    }
};

export default caseReducer;
